var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#288ced;}.b{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1106 -10)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 25,
    height: 25,
    rx: 12.5,
    transform: "translate(1106 10)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11.928,8.2A6.682,6.682,0,0,0,6,4.5,6.683,6.683,0,0,0,.073,8.2a.674.674,0,0,0,0,.608A6.682,6.682,0,0,0,6,12.5a6.683,6.683,0,0,0,5.928-3.7A.674.674,0,0,0,11.928,8.2ZM6,11.5a3,3,0,1,1,3-3A3,3,0,0,1,6,11.5Zm0-5a1.986,1.986,0,0,0-.527.079A1,1,0,0,1,4.079,7.973,2,2,0,1,0,6,6.5Z",
    transform: "translate(1113 14.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.87dfe8fcab16c7042e86240ae7f9df8c.svg";
export { ForwardRef as ReactComponent };